import script from "./HelpDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./HelpDialog.vue?vue&type=script&setup=true&lang=js"

import "./HelpDialog.vue?vue&type=style&index=0&id=394a8048&scoped=true&lang=css"
import "./HelpDialog.vue?vue&type=style&index=1&id=394a8048&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-394a8048"]])

export default __exports__